
export const createQueryString = (query) => {
    let queryString = ""



    if(query.Kampania){
        let Kampania = query.Kampania.replace("&","[AND]")
        Kampania = Kampania.replace("+","[PLUS]")
        Kampania = Kampania.replace("#","[HASH]")
        Kampania = Kampania.replace("(","[LNAW]")
        Kampania = Kampania.replace(")","[PNAW]")

        queryString += `Kampania=${Kampania}&`
    }

    if(query.Klient){
        let klient  = query.Klient.replace("&","[AND]")
        klient = klient.replace("+","[PLUS]")
        klient = klient.replace("(","[LNAW]")
        klient = klient.replace(")","[PNAW]")
        
        queryString += `Klient=${klient}&`
    }

    if(query.Kategoria)
        queryString += `Kategoria=${query.Kategoria}&`
    
    if(query.Format !== ""){
        let format = query.Format.replace("(","[LNAW]")
        format = format.replace("(","[LNAW]")
        format = format.replace(")","[PNAW]")
        queryString += `Format=${format.replace("&","[AND]")}&`
    }

    return queryString
}


